// The classic chevron thumb (.pipe-thumb) of the Ecotile and Maintenance
// pipelines — GPU edition (5-Nov-2026).
//
// The thumb is three pieces (<i class="l|m|r">) moved ONLY by transform, so
// the CSS transitions run on the GPU and a glide never repaints the bar:
//   .l = left end (notch, or rounded on the first stage)
//   .m = plain middle, stretched with scaleX (same colour all the way across,
//        the gloss is top-to-bottom only, so stretching it is invisible)
//   .r = right end (point, or rounded on the last stage)
// All three share one easing, so both edges move together exactly as the old
// transform + width transition did. (Was: `width` in the transition, which
// re-laid-out and repainted the bar every frame on the main thread.)
// The ERP's own rail (PipelineRail.js) uses the same idea with its own
// stretchy two-curve glide.

const CAP = 18;     // = .pipe-thumb > i width in App.css; ≥ the 11px point + room, ≥ the 16px end radius
const BASE = 100;   // = .pipe-thumb > .m width in App.css

export function placePipeThumb(thumb, tab, { color, isFirst = false, isLast = false, ov = 11, instant = false } = {}) {
  if (!thumb) return;
  if (!tab) { thumb.style.opacity = "0"; return; }
  const [l, m, r] = thumb.children;
  if (!l || !m || !r) return;
  thumb.classList.toggle("pipe-thumb-first", isFirst);
  thumb.classList.toggle("pipe-thumb-last", isLast);
  const lo = isFirst ? 3 : ov;
  const ro = isLast ? 3 : ov;
  const left = tab.offsetLeft - lo;
  const right = tab.offsetLeft + tab.offsetWidth + ro;
  const parts = [thumb, l, m, r];
  if (instant) parts.forEach((el) => { el.style.transition = "none"; });
  thumb.style.opacity = "1";
  if (color) thumb.style.backgroundColor = color;
  const x0 = left + CAP - 1;          // the middle tucks 1px under each end: no seam
  const x1 = right - CAP + 1;
  l.style.transform = `translateX(${left}px)`;
  m.style.transform = `translateX(${x0}px) scaleX(${Math.max(x1 - x0, 0) / BASE})`;
  r.style.transform = `translateX(${right - CAP}px)`;
  if (instant) {
    void thumb.offsetHeight;
    parts.forEach((el) => { el.style.transition = ""; });
  }
}

// Run fn once the current frame has reached the screen, so a glide started in
// a click handler is already on the GPU before React builds the next view.
// The 100ms backstop covers a paused frame loop.
export function afterNextFrame(fn) {
  let done = false;
  const run = () => { if (!done) { done = true; fn(); } };
  requestAnimationFrame(() => setTimeout(run, 0));
  setTimeout(run, 100);
}
